import { render, staticRenderFns } from "./DoorSensor.vue?vue&type=template&id=0c396af9&scoped=true&"
import script from "./DoorSensor.vue?vue&type=script&lang=js&"
export * from "./DoorSensor.vue?vue&type=script&lang=js&"
import style0 from "./DoorSensor.vue?vue&type=style&index=0&id=0c396af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c396af9",
  null
  
)

export default component.exports